import { useState, useCallback } from 'react';

// Ripple 타입 정의
interface Ripple {
  id: number;
  style: React.CSSProperties;
}

// 커스텀 훅: useRipple
export const useRipple = () => {
  const [ripples, setRipples] = useState<Ripple[]>([]);

  // createRipple 이벤트 핸들러
  const createRipple = useCallback((e: React.MouseEvent<HTMLElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;

    // 새로운 ripple 추가
    const newRipple: Ripple = {
      id: Date.now(),
      style: {
        top: `${y}px`,
        left: `${x}px`,
        width: `${size}px`,
        height: `${size}px`,
      },
    };

    // ripple 추가
    setRipples(prevRipples => [...prevRipples, newRipple]);

    // 특정 시간이 지난 후 ripple 제거
    setTimeout(() => {
      setRipples(prevRipples =>
        prevRipples.filter(ripple => ripple.id !== newRipple.id)
      );
    }, 600);
  }, []);

  return { ripples, createRipple };
};
